module.exports = "/_next/static/images/buger-9b79f03afa4f3a242b14a5f7f883a7ab.jpg";